import {makeGetExamsLocalities} from 'main/factories/usecases';
import {makeGetHealthLocalities} from 'main/factories/usecases/private/booking-flow/remote-health-booking';
import {FactoryType} from './types';
import {FlowEnum} from '../../../constants/flowEnum';

const getLocalitiesFactory = (flowType: FlowEnum): FactoryType => {
	if (flowType === FlowEnum.EXAM) {
		return makeGetExamsLocalities();
	}
	return makeGetHealthLocalities();
};

export {getLocalitiesFactory};
